var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErxDeliveryProcessingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2223 11.5116L16.253 12.2049L17.1052 10.9377C17.6362 12.7817 17.1357 14.813 15.7514 16.1972C13.67 18.2786 10.283 18.2786 8.20134 16.1972L7.32306 17.0756C8.60601 18.3585 10.2912 19 11.9765 19C13.6616 19 15.3469 18.3585 16.6299 17.0756C18.3309 15.3744 18.9494 12.8802 18.3043 10.6124L19.6677 11.5294L20.361 10.4986L17.2919 8.43435L15.2223 11.5116Z",
    fill: "#F39200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1387 12.4884L7.10794 11.7951L6.25575 13.0622C5.72489 11.2183 6.22531 9.18687 7.6095 7.80271C9.69101 5.72124 13.0779 5.72124 15.1595 7.80271L16.038 6.92434C13.4721 4.3585 9.297 4.3586 6.73122 6.92434C5.02995 8.62549 4.41172 11.1197 5.05666 13.3875L3.69329 12.4705L3 13.5013L6.0691 15.5656L8.1387 12.4884Z",
    fill: "#F39200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErxDeliveryProcessingIcon);
export default __webpack_public_path__ + "static/media/erx-delivery-processing-icon.933c3220fd6b85bfb0d3a03baf36c543.svg";
export { ForwardRef as ReactComponent };